module.exports = __webpack_public_path__ + "img/upperCaseE.db53123e.svg";